module.exports = __webpack_public_path__ + "static/media/admin-dashboard.96116a6d.png";